var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInProgress = function SvgInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600098 0H13.6001L20.6001 4V20H7.6001L0.600098 16V0Z",
    fill: "#A2C3F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 6.25C8.52888 6.25 6.84995 7.92893 6.84995 10C6.84995 10.1023 6.85404 10.2036 6.86205 10.3038L7.47837 9.51492L8.26638 10.1306L6.96039 11.8022C6.79039 12.0198 6.47617 12.0583 6.25857 11.8883L4.58691 10.5824L5.20256 9.79434L5.85978 10.3078C5.85326 10.206 5.84995 10.1034 5.84995 10C5.84995 7.37665 7.9766 5.25 10.6 5.25C12.0513 5.25 13.351 5.90153 14.2215 6.92629L13.4594 7.57371C12.7707 6.76306 11.7455 6.25 10.6 6.25Z",
    fill: "#004ECC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3401 9.69214L15.9973 10.2056L16.613 9.41757L14.9413 8.1116C14.7237 7.9416 14.4095 7.98018 14.2395 8.19778L12.9335 9.86936L13.7215 10.485L14.3378 9.69618C14.3459 9.79633 14.35 9.89765 14.35 10C14.35 12.0711 12.671 13.75 10.6 13.75C9.45438 13.75 8.42916 13.2369 7.74054 12.4263L6.9784 13.0737C7.84891 14.0985 9.1486 14.75 10.6 14.75C13.2233 14.75 15.35 12.6234 15.35 10C15.35 9.89662 15.3466 9.79397 15.3401 9.69214Z",
    fill: "#004ECC"
  })));
};
export { SvgInProgress as ReactComponent };
export default __webpack_public_path__ + "assets/c89bbd2e.svg";